if (document.querySelector('[data-autoplay]')){
    document.querySelectorAll('[data-autoplay]').forEach(item=>{
        var swiper = new Swiper(item, {
            pagination: {
              el: item.querySelector('.swiper-pagination'),
            },
            autoplay: {
                delay: parseInt(item.dataset.autoplay),
                disableOnInteraction: false,
            },
        });
    })
}